import React, { useCallback, useEffect, useState, Component } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Navigation } from './components/Navigation';
import { BottomNav } from './components/BottomNav';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FrontendSection } from './components/FrontendSection';
import { CmsSection } from './components/CmsSection';
import { WorkflowSection } from './components/WorkflowSection';
import { PhasesSection } from './components/PhasesSection';
import { CostSection } from './components/CostSection';
const slides = [{
  id: 'hero',
  component: HeroSection
}, {
  id: 'problem',
  component: ProblemSection
}, {
  id: 'frontend',
  component: FrontendSection
}, {
  id: 'cms',
  component: CmsSection
}, {
  id: 'workflow',
  component: WorkflowSection
}, {
  id: 'phases',
  component: PhasesSection
}, {
  id: 'pricing',
  component: CostSection
}];
export function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(0);
  const goToSlide = useCallback((index: number) => {
    setDirection(index > currentSlide ? 1 : -1);
    setCurrentSlide(index);
  }, [currentSlide]);
  const nextSlide = useCallback(() => {
    if (currentSlide < slides.length - 1) {
      goToSlide(currentSlide + 1);
    }
  }, [currentSlide, goToSlide]);
  const prevSlide = useCallback(() => {
    if (currentSlide > 0) {
      goToSlide(currentSlide - 1);
    }
  }, [currentSlide, goToSlide]);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') nextSlide();else if (e.key === 'ArrowLeft') prevSlide();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [nextSlide, prevSlide]);
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 800 : -800,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 800 : -800,
      opacity: 0
    })
  };
  const CurrentComponent = slides[currentSlide].component;
  return <div className="fixed inset-0 overflow-hidden bg-white text-[#1a1a1a] font-sans selection:bg-[#EB0A1E]/20 selection:text-[#1a1a1a]" data-id="element-0">
      <Navigation currentSlide={currentSlide} goToSlide={goToSlide} data-id="element-1" />

      <main className="absolute inset-0 pt-16 pb-16 lg:pt-20 lg:pb-20 overflow-hidden" data-id="element-2">
        <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-3">
          <motion.div key={currentSlide} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
          x: {
            type: 'spring',
            stiffness: 300,
            damping: 30
          },
          opacity: {
            duration: 0.2
          }
        }} className="absolute inset-0 w-full h-full" data-id="element-4">
            <CurrentComponent goToSlide={goToSlide} data-id="element-5" />
          </motion.div>
        </AnimatePresence>
      </main>

      <BottomNav currentSlide={currentSlide} totalSlides={slides.length} nextSlide={nextSlide} prevSlide={prevSlide} data-id="element-6" />
    </div>;
}